import { useState } from 'react';

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { useDebounce } from 'react-use';

import { useAppDispatch } from '@pkg/hooks';
import { getNextPageParam, getPagesPagingParams } from '@pkg/hooks/deprecated';

import { callGetUsers } from '@app/client/resources/admin/users';
import { prefetch2FA } from '@app/helpers';

export const ADMIN_USER_CACHE = 'ADMIN_USER_CACHE';

type UseGetUsersType = {
    query?: string;
    limit?: number;
    page?: number;
};

export function useGetUsers({ query: queryProp, page, limit }: UseGetUsersType) {
    const dispatch = useAppDispatch();
    const [query, setQuery] = useState('');
    useDebounce(() => setQuery(queryProp || ''), 100, [queryProp]);

    const { data, ...rest } = useInfiniteQuery({
        queryKey: [ADMIN_USER_CACHE, query, page, limit],
        queryFn: ({ signal, pageParam = 0 }) =>
            callGetUsers({
                userQuery: query,
                page: pageParam,
                limit,
                prefetch: prefetch2FA(dispatch),
                settings: { signal },
            }),

        retry: false,
        placeholderData: keepPreviousData,
        initialPageParam: 0,
        getNextPageParam,
    });

    const pagingParams = getPagesPagingParams(data?.pages);

    return { data, pagingParams, ...rest };
}
